export class DocumentLanguageModule {
	constructor() {
		this.languageFallback = 'nl';
	}
	getLanguageFromDocument() {
		// console.log('guessLanguageFromHtmlLanguage');
		if (typeof document !== 'undefined' && document.documentElement && document.documentElement.hasAttribute('lang') === true) {
			let language = document.documentElement.getAttribute('lang');
			// console.log('language attribute on html', language);

			return language
		}
		return this.languageFallback;
	}

	guessLanguageFromHtmlLanguage() {
		// console.log('guessLanguageFromHtmlLanguage');
		if (typeof document !== 'undefined' && document.documentElement && document.documentElement.hasAttribute('lang') === true) {
			let language = document.documentElement.getAttribute('lang');
			if (language.length > 1) {
				let firstTwoCharacters = language.substr(0, 2);
				switch (firstTwoCharacters) {
					case 'en':
					case 'it':
						this.language = 'en';
						break;
					case 'nl':
						this.language = 'nl';
				}
				return this.language;
			}
			return language;
		}
		return null;
	}

	guessLanguageFromUri() {
		if (typeof window !== 'undefined') {
			//guess language from URI
			let path = window.location.pathname;
			// console.log('path', path);
			if (path.length > 2) {
				let firstThreeCharacters = path.substr(0, 3);
				console.log('first three characters', firstThreeCharacters);
				switch (firstThreeCharacters) {
					case '/en':
					case '/it':
						this.language = 'en';
						break;
					case '/nl':
						this.language = 'nl';
				}
				return this.language;
			}
		}
		return null; // no language found, fall back to original cookies enabler configuration
	}
}